import { defineAsyncComponent } from '@vue/composition-api';

const ElementVideo = defineAsyncComponent(
  () => import(/* webpackChunkName: "element-video" */ './ElementVideo.vue')
);


export { ElementVideo };
